import { useContext } from "react";
import { FileViewerContext } from "../contexts/FileViewerContext";

export const useFileViewer = () => useContext(FileViewerContext);
